// Email subsystem validation -- iteration 076
import { z } from "zod";

export const emailLogListQuerySchema = z.object({
  page: z.coerce.number().int().min(1).default(1),
  page_size: z.coerce.number().int().min(1).max(100).default(25),
  status: z.enum(["queued", "sent", "delivered", "bounced", "failed"]).optional(),
  template: z.string().optional(),
  search: z.string().optional(),
});

export type EmailLogListQuery = z.infer<typeof emailLogListQuerySchema>;
